<template>
<v-card flat >
  <!-- <v-btn @click='fetchTrigger++' ></v-btn> -->
  <!-- <pre v-text="params" /> -->
  <v-card-title class="pa-0 grey lighten-4">
    <v-btn small round
      @click="activeTab=0;setPreviousParams()"
      :outline="activeTab===1"
      color="info" >Recent and previous appointments</v-btn>
    <v-btn small round
      @click="activeTab=1;setUpcomingParams()"
      :outline="activeTab===0" color="info" >Upcoming appointments</v-btn>
    <v-spacer/>
    <v-chip class="mr-5 overline" label >
      Today:
      {{todaysDate}}
    </v-chip>
  </v-card-title>
  <v-divider/>
  <!-- <pre v-text="practitioners" />
  <pre v-text="facetCount" /> -->
  <!-- <tombstone v-show='loading' /> -->
  <appointment-list dense group-by-month
    :params="params"
    :title="title"
    :touch="fetchTrigger"
    :page-size="pageSize"
    :selected.sync="selected"
    :loading.sync="loading"
    facets="status,practitioner"
    @update:request="setRequest" >

    <v-card-title slot="top" class="py-0 hidden-xs-only" >

      <v-spacer/>
      <status-picker
        v-model="statuses"
        :facets="facetCount.status"
        @input="updateParams" />

      <v-divider vertical class="mx-2" />

      <v-chip small
        v-for="p in practitioners"
        @click="setSelectedPractitioner(p.id)"
        :key="p.id" >

        <v-avatar dark class="white--text mr-0 grey darken-2" >{{ p.count }}</v-avatar>

        <v-avatar v-if="p.img" class="ml-1" >
          <v-img :src="p.img" />
        </v-avatar>

        {{p.full_name}}

        <v-icon v-if="isSelectedPractitioner(p.id)" small >check</v-icon>

      </v-chip>
      <!-- {{selectedPractitioners}} -->
      <!-- <v-spacer/> -->
    </v-card-title>
  </appointment-list>


  <!-- <appointment-picker dense
    class='mx-1'
    :compact='true'
    :initial-page-size='5'
    :clear-date-range='true'
    :initial-window='1'
    :relationship='relationship'
    :fetch-trigger='fetchTrigger'
    @ready="initted=true" /> -->
  <!-- <tombstone v-if='initted===false' /> -->
  <v-btn v-if='relationship && relationship.id'
    @click='launchCreateAppointment({relationship})'
    fab top right small dark absolute
    color='pink' >
    <v-icon dark >add</v-icon>
  </v-btn>
</v-card>
</template>

<script>
// import AppointmentPicker from '@/components/pickers/AppointmentPicker/index.vue'
import AppointmentList from '@/components/lists/AppointmentList.vue'
import StatusPicker from '@/components/pickers/StatusPicker.vue'
import Tombstone from '@/components/app/Tombstone'
import Vue from 'vue'

export default {
  name: 'ClientAppointments',
  components: {
    AppointmentList,
    StatusPicker,
    Tombstone
  },
  props: {
    appointments: { type: Array, default: () => { return [] } },
    // pageSize: { type: Number, default: 10 },
    relationship: { type: Object, required: false }
  },
  data () {
    return {
      selected: [],
      selectedPractitioners: [],
      statuses: [],
      params: {},
      initted: false,
      fetchTrigger: 0,
      activeTab: 0,
      loading: false,
      pageSize: 5,
      request: {}
    }
  },
  watch: {
    relationshipId: {
      immediate: true,
      handler () {
        this.updateParams()
      }
    },
    watchString () {
      this.fetchTrigger++
    }
  },
  methods: {
    updateParams () {
      if (this.activeTab === 0) { this.setPreviousParams() }
      if (this.activeTab === 1) { this.setUpcomingParams() }
    },
    setRequest (req) {
      this.request = req
    },
    setSelectedPractitioner (pId) {
      let selectedIndex = this.selectedPractitioners.indexOf(pId)
      if (selectedIndex > -1) {
        this.selectedPractitioners.splice(selectedIndex, 1)
      } else {
        this.selectedPractitioners.push(pId)
      }
      if (this.selectedPractitioners && this.selectedPractitioners.length > 0) {
        Vue.set(this.params, 'practitioner_id-in', this.selectedPractitioners.join(','))
      } else {
        Vue.delete(this.params, 'practitioner_id-in')
        this.fetchTrigger++
      }
    },
    isSelectedPractitioner (pId) {
      let selectedIndex = this.selectedPractitioners.indexOf(pId)
      if (selectedIndex > -1) { return true }
      return false
    },
    setPreviousParams () {
      let p = {
        relationships: this.relationshipId,
        before_utc: this.todaysDate,
        ordering: '-start_time',
        page_size: this.pageSize
      }
      if (this.statuses && this.statuses.length > 0) {
        p['status-in'] = this.statuses.join(',')
      }
      this.params = p
    },
    setUpcomingParams () {
      this.params = {
        relationships: this.relationshipId,
        after_utc: this.todaysDate,
        ordering: 'start_time',
        page_size: this.pageSize
      }
    }
  },
  computed: {
    relationshipId () {
      if (this.relationship && this.relationship.id) {
        return this.relationship.id
      }
      return null
    },
    todaysDate () { return this.dateformat(null, 'YYYY-MM-DD') },
    facetCount () { return this.getObjectPath(this.request, 'result.facets', {stastus: {}, practitioner: {}}) },
    title () {
      if (this.activeTab === 0) {
        return `Appointments before today (${this.todaysDate}) - most recent first`
      }
      if (this.activeTab === 1) {
        return `Appointments after today (${this.todaysDate}) - newest first`
      }
    },
    practitioners () {
      let facets = this.getObjectPath(this.facetCount, 'practitioner', {})
      let ids = Object.keys(facets)
      let ps = []
      ids.forEach((pId) => {
        let cnt = facets[pId]
        let p = this.$store.getters.getPractitionerById(pId)
        if (p) {
          let img = this.getProfilePicture(p)
          let item = {
            id: pId,
            count: cnt,
            full_name: p.full_name,
            img
          }
          ps.push(item)
        }
      })
      return ps
    },
    watchString () {
      return this.globalPaymentTouch.touch + this.globalAppointmentQuickCreate.touch + this.globalInvoiceQuickCreate.touch
    },
    globalPaymentTouch () {
      return this.$store.getters.getGlobalDialogEvent('Payment')
    },
    globalAppointmentQuickCreate () {
      return this.$store.getters.getGlobalDialogEvent('AppointmentQuickCreate')
    },
    globalInvoiceQuickCreate () {
      return this.$store.getters.getGlobalDialogEvent('InvoiceQuickCreate')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// ClientAppointments.vue?3279436d